import axios from "axios";

export { default as Auth } from "./Auth";
export { default as SomaPlace } from "../SomaPlace/SomaPlace";

export default axios.create({
  // eslint-disable-next-line no-restricted-globals
  // baseURL: `${location.origin}:8080`,
  baseURL: "https://mais-atacado-backend.somalabs.com.br/",
  transformRequest: [
    (data, headers) => {
      const token = localStorage.getItem("CurUser");
      if (token) {
        headers.common.Authorization = `Bearer ${token}`;
      } else {
        console.log("Cade o KCT do login");
      }
      return data;
    },
    ...axios.defaults.transformRequest,
  ],
});
